import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { User } from '../../features/user-management/components/user/model/user';
import { Group } from '../../features/user-management/components/user/model/group';

export class UpdateCurrentPaginatedUsersAction {
  static readonly type = '[User Management] Update Current Paginated Users';
  constructor(public users: User[]) {}
}

export class UpdateCurrentPaginatedGroupsAction {
  static readonly type = '[User Management] Update Current Paginated Groups';
  constructor(public groups: Group[]) {}
}

export class UpdateUserGroupsAction {
  static readonly type = '[UserManagement] Update User Groups';
  constructor(public groupNames: string[]) {}
}

export class UserManagementStateModel {
  loading = true;
  currentPaginatedUsers: User[];
  currentPaginatedGroups: Group[];
  updateUserGroups: string[];
}

const defaultState = {
  loading: true,
  currentPaginatedUsers: [] as User[],
  currentPaginatedGroups: [] as Group[],
  updateUserGroups: [] as string[]
};

export class ResetUserManagementStateAction {
  static readonly type = '[User Management] User Management State Reset';
}

export class UnlockUserManagementStateAction {
  static readonly type = '[User Management] User Management State Unlock';
}

@State<UserManagementStateModel>({
  name: 'userManagement',
  defaults: defaultState
})
@Injectable()
export class UserManagementState {
  constructor() {}

  @Action(UpdateCurrentPaginatedUsersAction)
  setCurrentPaginatedUsers({ patchState }: StateContext<UserManagementStateModel>, { users }: UpdateCurrentPaginatedUsersAction) {
    patchState({ currentPaginatedUsers: users });
  }

  @Action(UpdateCurrentPaginatedGroupsAction)
  setCurrentPaginatedGroups({ patchState }: StateContext<UserManagementStateModel>, { groups }: UpdateCurrentPaginatedGroupsAction) {
    patchState({ currentPaginatedGroups: groups });
  }

  @Action(UpdateUserGroupsAction)
  updateUserGroups({ patchState }: StateContext<UserManagementStateModel>, { groupNames }: UpdateUserGroupsAction) {
    patchState({ updateUserGroups: groupNames });
  }

  @Selector()
  static currentPaginatedUsers(state: UserManagementStateModel) {
    return state.currentPaginatedUsers;
  }

  @Selector()
  static currentPaginatedGroups(state: UserManagementStateModel) {
    return state.currentPaginatedGroups;
  }

  @Selector()
  static updateUserGroups(state: UserManagementStateModel) {
    return state.updateUserGroups;
  }

  @Action(ResetUserManagementStateAction)
  resetUserManagementStateAction({ patchState }: StateContext<UserManagementStateModel>) {
    patchState(defaultState);
  }

  @Action(UnlockUserManagementStateAction)
  unlockUserManagementStateAction({ patchState }: StateContext<UserManagementStateModel>) {
    patchState({ loading: true });
  }
}
